<template>
  <div class="index">
    <img class="dh" src="../../assets/imagesHz/splogo.gif" />
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      msg: ""
    };
  },
  mounted() {
    this.clickJump();
  },
  methods: {
    clickJump() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.$router.push('/indexdh');
      }, 1400);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.index {
  width: 100%;
  height: 100vh;

  overflow: hidden;
}
.dh {
  margin: 0 auto;
}


</style>



// WEBPACK FOOTER //
// src/view/index/index.vue